<template>
  <div class="intro-container">
    

    <!-- <div class="reveal"></div> -->
    <div class="spartan-svg">
      <img src="../assets/animatedSVG/helmetgif_1x.gif" alt="">
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: "SpartanIntro",
  created() {
    setTimeout(() => {
      console.log('redirect to spartan page');
      // this.$router.push({ path: '/spartan' });
      window.location.href="http://spartan-builders.com/spartan";
     },5000);
  },
   watch: {
      '$route':{
        handler: (to) => {
          document.title = to.meta.title || 'Spartan Builders'
        },
         immediate: true
      }
    } 
};
</script>

<style lang="scss" scoped>
@import "./src/stylesheets/base/_variables.scss";
@import "./src/stylesheets/ui/_animations.scss";

.intro-container {
  display: flex;

  @media screen and (max-width: $medium-bp) {
    flex-direction: column;
  }

  @media screen and (min-width: $medium-bp+0.1) {
    flex-direction: row;
  }

  @media screen and (min-width: $medium-bp+0.1) and (max-width: 1024px) and (min-height: 1025px) {
    flex-direction: column;
  }
}



</style>
